// extracted by mini-css-extract-plugin
export var dividerContainer = "_8o-0";
export var line = "_8o-1";